import { Link } from 'react-router-dom';
import { ROUTES } from '../routes.js';
import './LegalPage.css';
import './NotFound.css';

export default function NotFound() {
  return (
    <article className="legal notfound">
      <span className="eyebrow">404</span>
      <h1>
        Diese Seite ist <em>off market</em>.
      </h1>
      <p>
        Der gesuchte Inhalt existiert nicht (mehr) oder wurde verschoben.
        Zurück zur Startseite – dort finden Sie alles, was öffentlich ist.
      </p>
      <div className="notfound__actions">
        <Link to={ROUTES.home} className="btn-primary">
          Zur Startseite
        </Link>
      </div>
    </article>
  );
}
